import { render } from "./Draggable.vue?vue&type=template&id=0981d6bc"
import script from "./Draggable.vue?vue&type=script&lang=js"
export * from "./Draggable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\osago\\landing-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__